// import React, { useState, useEffect } from 'react';
// import '../styles/Attendance.css'; // Reusing your attendance styles

// const ManagerMedicalReports = () => {
//     const [reports, setReports] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const [viewMode, setViewMode] = useState('pending'); // 'pending' or 'history'
//     const [selectedPhoto, setSelectedPhoto] = useState(null);
//     const [selectedLeaveId, setSelectedLeaveId] = useState(null);

//     // 1. Get Manager Details from LocalStorage
//     // We assume the manager's department name is stored in the 'HOD' field
//     const userData = JSON.parse(localStorage.getItem('userData'));
//     const managerDept = userData ? userData.HOD : ''; 

//     useEffect(() => {
//         if (managerDept) {
//             fetchReports();
//         }
//     }, [viewMode, managerDept]);

//     const fetchReports = async () => {
//         setLoading(true);
//         try {
//             // 2. Fetching reports filtered by the manager's department (HOD field)
//             const response = await fetch(
//                 `/gt-api/get_manager_medical_reports.php?mode=${viewMode}&dept=${encodeURIComponent(managerDept)}`
//             );
//             const data = await response.json();
//             if (data.success) {
//                 setReports(data.reports);
//             } else {
//                 setReports([]);
//             }
//         } catch (error) {
//             console.error("Fetch Error:", error);
//         } finally {
//             setLoading(false);
//         }
//     };

//     const handleViewDocument = (fileName, leaveId) => {
//         const fileUrl = `/gt-api/uploads/medical_docs/${fileName}`;
//         setSelectedLeaveId(leaveId);
//         setSelectedPhoto(fileUrl);
//     };

//     const handleVerifyAction = async (actionType) => {
//         if (!selectedLeaveId) return;

//         const formData = new URLSearchParams();
//         formData.append('leave_id', selectedLeaveId);
//         formData.append('action', actionType);

//         try {
//             const response = await fetch("/gt-api/update_medical_status.php", {
//                 method: "POST",
//                 headers: { "Content-Type": "application/x-www-form-urlencoded" },
//                 body: formData.toString()
//             });
//             const result = await response.json();
//             if (result.success) {
//                 setSelectedPhoto(null);
//                 fetchReports();
//                 alert(`Document ${actionType === 'verify' ? 'Approved' : 'Rejected'} Successfully`);
//             }
//         } catch (error) {
//             console.error("Update Error:", error);
//         }
//     };

//     return (
//         <div className="attendance-module animate-fade">

//             {/* BRIGHT THEMED IMAGE OVERLAY */}
//             {selectedPhoto && (
//                 <div className="cyber-full-overlay" 
//                      onClick={() => setSelectedPhoto(null)} 
//                      style={{ 
//                         position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', 
//                         background: 'rgba(255, 255, 255, 0.95)', zIndex: 9999, 
//                         display: 'flex', flexDirection: 'column', alignItems: 'center', 
//                         justifyContent: 'center', backdropFilter: 'blur(10px)' 
//                      }}>

//                     <div style={{ background: '#fff', padding: '20px', borderRadius: '15px', boxShadow: '0 20px 50px rgba(0,0,0,0.1)', textAlign: 'center' }}>
//                         <h4 style={{ color: '#1e293b', marginBottom: '15px' }}>MEDICAL DOCUMENT VERIFICATION</h4>

//                         {viewMode === 'pending' && (
//                             <div style={{ display: 'flex', gap: '15px', marginBottom: '20px', justifyContent: 'center' }}>
//                                 <button className="btn-submit-cyber" onClick={(e) => { e.stopPropagation(); handleVerifyAction('verify'); }}>✓ APPROVE</button>
//                                 <button className="btn-no" style={{ background: '#ef4444', color: '#fff', border: 'none', padding: '10px 20px', borderRadius: '5px', fontWeight: 'bold' }} onClick={(e) => { e.stopPropagation(); handleVerifyAction('reject'); }}>✕ REJECT</button>
//                             </div>
//                         )}

//                         <img src={selectedPhoto} alt="Medical Report" style={{ maxWidth: '70vw', maxHeight: '60vh', borderRadius: '8px', border: '1px solid #e2e8f0' }} onClick={(e) => e.stopPropagation()} />
//                         <p style={{ color: '#64748b', marginTop: '15px', fontSize: '0.8rem' }}>Click anywhere outside to close</p>
//                     </div>
//                 </div>
//             )}

//             <div className="panel glass">
//                 <div className="panel-header" style={{ borderBottom: '1px solid #e2e8f0' }}>
//                     <div style={{ display: 'flex', gap: '25px' }}>
//                         <h3 
//                             className={`panel-title ${viewMode === 'pending' ? 'active-tab' : 'inactive-tab'}`} 
//                             onClick={() => setViewMode('pending')}
//                             style={{ 
//                                 cursor: 'pointer', 
//                                 color: viewMode === 'pending' ? '#2563eb' : '#64748b',
//                                 borderBottom: viewMode === 'pending' ? '3px solid #2563eb' : 'none',
//                                 paddingBottom: '10px'
//                             }}
//                         >
//                             {managerDept.toUpperCase()} PENDING
//                         </h3>
//                         <h3 
//                             className={`panel-title ${viewMode === 'history' ? 'active-tab' : 'inactive-tab'}`} 
//                             onClick={() => setViewMode('history')}
//                             style={{ 
//                                 cursor: 'pointer', 
//                                 color: viewMode === 'history' ? '#2563eb' : '#64748b',
//                                 borderBottom: viewMode === 'history' ? '3px solid #2563eb' : 'none',
//                                 paddingBottom: '10px'
//                             }}
//                         >
//                             DEPARTMENT HISTORY
//                         </h3>
//                     </div>
//                     <span className="deduction-badge" style={{ background: '#3b82f6', color: '#fff' }}>{reports.length} RECORDS</span>
//                 </div>

//                 <div className="table-scroll">
//                     {loading ? (
//                         <div style={{ padding: '40px', textAlign: 'center', color: '#64748b' }}>Loading Department Data...</div>
//                     ) : (
//                         <table className="history-table">
//                             <thead>
//                                 <tr style={{ background: '#f8fafc' }}>
//                                     <th style={{ color: '#1e293b' }}>EMP_ID</th>
//                                     <th style={{ color: '#1e293b' }}>EMPLOYEE_NAME</th>
//                                     <th style={{ color: '#1e293b' }}>PERIOD</th>
//                                     <th style={{ color: '#1e293b' }}>STATUS</th>
//                                     <th style={{ color: '#1e293b' }}>ACTION</th>
//                                 </tr>
//                             </thead>
//                             <tbody>
//                                 {reports.length > 0 ? reports.map((report) => (
//                                     <tr key={report.id} className="history-row">
//                                         <td style={{ fontWeight: '700' }}>{report.empid}</td>
//                                         <td>{report.firstName} {report.lastName}</td>
//                                         <td>{report.fromdate} <span style={{color: '#3b82f6'}}>→</span> {report.todate}</td>
//                                         <td>
//                                             {viewMode === 'history' ? (
//                                                 <span className={`status-pill ${report.medical_doc_status === '1' ? 'approved' : 'rejected'}`}>
//                                                     {report.medical_doc_status === '1' ? 'VERIFIED' : 'REJECTED'}
//                                                 </span>
//                                             ) : (
//                                                 <span className="status-pill pending">WAITING</span>
//                                             )}
//                                         </td>
//                                         <td>
//                                             <button className="btn-action approve" onClick={() => handleViewDocument(report.medical_doc, report.id)}>
//                                                 OPEN_FILE
//                                             </button>
//                                         </td>
//                                     </tr>
//                                 )) : (
//                                     <tr>
//                                         <td colSpan="5" style={{ textAlign: 'center', padding: '50px', color: '#94a3b8' }}>
//                                             No medical reports found for the {managerDept} department.
//                                         </td>
//                                     </tr>
//                                 )}
//                             </tbody>
//                         </table>
//                     )}
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default ManagerMedicalReports;












// import React, { useState, useEffect } from 'react';
// import '../styles/Attendance.css'; 

// const ManagerMedicalReports = () => {
//     const [reports, setReports] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const [viewMode, setViewMode] = useState('pending'); // 'pending' or 'history'
//     const [selectedPhoto, setSelectedPhoto] = useState(null);
//     const [selectedLeaveId, setSelectedLeaveId] = useState(null);

//     // 1. Get Manager Details and identify the Department column
//     const userData = JSON.parse(localStorage.getItem('userData'));

//     // We check every possible key (Department, dept, or HOD) to find the filter value
//     const managerDept = userData ? (userData.Department || userData.dept || userData.HOD || '') : ''; 

//     useEffect(() => {
//         // Only fetch if we have a department to filter by
//         if (managerDept) {
//             fetchReports();
//         } else {
//             setLoading(false);
//             console.warn("Manager Department not found in LocalStorage.");
//         }
//     }, [viewMode, managerDept]);

//     const fetchReports = async () => {
//         setLoading(true);
//         try {
//             // Using the new PHP endpoint we created
//             const response = await fetch(
//                 `/gt-api/get_manager_medical_reports.php?mode=${viewMode}&dept=${encodeURIComponent(managerDept)}`
//             );
//             const data = await response.json();

//             if (data.success) {
//                 setReports(data.reports);
//             } else {
//                 setReports([]);
//             }
//         } catch (error) {
//             console.error("Fetch Error:", error);
//         } finally {
//             setLoading(false);
//         }
//     };

//     const handleViewDocument = (fileName, leaveId) => {
//         const fileUrl = `/gt-api/uploads/medical_docs/${fileName}`;
//         setSelectedLeaveId(leaveId);
//         setSelectedPhoto(fileUrl);
//     };

//     const handleVerifyAction = async (actionType) => {
//         if (!selectedLeaveId) return;

//         const formData = new URLSearchParams();
//         formData.append('leave_id', selectedLeaveId);
//         formData.append('action', actionType);

//         try {
//             const response = await fetch("/gt-api/update_medical_status.php", {
//                 method: "POST",
//                 headers: { "Content-Type": "application/x-www-form-urlencoded" },
//                 body: formData.toString()
//             });
//             const result = await response.json();
//             if (result.success) {
//                 setSelectedPhoto(null);
//                 fetchReports();
//                 alert(`Document ${actionType === 'verify' ? 'Approved' : 'Rejected'} Successfully`);
//             }
//         } catch (error) {
//             console.error("Update Error:", error);
//         }
//     };

//     return (
//         <div className="attendance-module animate-fade">

//             {/* DOCUMENT PREVIEW OVERLAY */}
//             {selectedPhoto && (
//                 <div className="cyber-full-overlay" 
//                      onClick={() => setSelectedPhoto(null)} 
//                      style={{ 
//                         position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', 
//                         background: 'rgba(255, 255, 255, 0.95)', zIndex: 9999, 
//                         display: 'flex', flexDirection: 'column', alignItems: 'center', 
//                         justifyContent: 'center', backdropFilter: 'blur(10px)' 
//                      }}>

//                     <div style={{ background: '#fff', padding: '20px', borderRadius: '15px', boxShadow: '0 20px 50px rgba(0,0,0,0.1)', textAlign: 'center' }}>
//                         <h4 style={{ color: '#1e293b', marginBottom: '15px' }}>MEDICAL DOCUMENT VERIFICATION</h4>

//                         {viewMode === 'pending' && (
//                             <div style={{ display: 'flex', gap: '15px', marginBottom: '20px', justifyContent: 'center' }}>
//                                 <button className="btn-submit-cyber" onClick={(e) => { e.stopPropagation(); handleVerifyAction('verify'); }}>✓ APPROVE</button>
//                                 <button className="btn-no" style={{ background: '#ef4444', color: '#fff', border: 'none', padding: '10px 20px', borderRadius: '5px', fontWeight: 'bold' }} onClick={(e) => { e.stopPropagation(); handleVerifyAction('reject'); }}>✕ REJECT</button>
//                             </div>
//                         )}

//                         <img src={selectedPhoto} alt="Medical Report" style={{ maxWidth: '70vw', maxHeight: '60vh', borderRadius: '8px', border: '1px solid #e2e8f0' }} onClick={(e) => e.stopPropagation()} />
//                         <p style={{ color: '#64748b', marginTop: '15px', fontSize: '0.8rem' }}>Click anywhere outside to close</p>
//                     </div>
//                 </div>
//             )}

//             <div className="panel glass">
//                 <div className="panel-header" style={{ borderBottom: '1px solid #e2e8f0' }}>
//                     <div style={{ display: 'flex', gap: '25px' }}>
//                         <h3 
//                             className={`panel-title ${viewMode === 'pending' ? 'active-tab' : 'inactive-tab'}`} 
//                             onClick={() => setViewMode('pending')}
//                             style={{ 
//                                 cursor: 'pointer', 
//                                 color: viewMode === 'pending' ? '#2563eb' : '#64748b',
//                                 borderBottom: viewMode === 'pending' ? '3px solid #2563eb' : 'none',
//                                 paddingBottom: '10px'
//                             }}
//                         >
//                             {managerDept ? managerDept.toUpperCase() : "DEPT"} PENDING
//                         </h3>
//                         <h3 
//                             className={`panel-title ${viewMode === 'history' ? 'active-tab' : 'inactive-tab'}`} 
//                             onClick={() => setViewMode('history')}
//                             style={{ 
//                                 cursor: 'pointer', 
//                                 color: viewMode === 'history' ? '#2563eb' : '#64748b',
//                                 borderBottom: viewMode === 'history' ? '3px solid #2563eb' : 'none',
//                                 paddingBottom: '10px'
//                             }}
//                         >
//                             DEPARTMENT HISTORY
//                         </h3>
//                     </div>
//                     <span className="deduction-badge" style={{ background: '#3b82f6', color: '#fff' }}>{reports.length} RECORDS</span>
//                 </div>

//                 <div className="table-scroll">
//                     {loading ? (
//                         <div style={{ padding: '40px', textAlign: 'center', color: '#64748b' }}>Loading Department Data...</div>
//                     ) : (
//                         <table className="history-table">
//                             <thead>
//                                 <tr style={{ background: '#f8fafc' }}>
//                                     <th style={{ color: '#1e293b' }}>EMP_ID</th>
//                                     <th style={{ color: '#1e293b' }}>EMPLOYEE_NAME</th>
//                                     <th style={{ color: '#1e293b' }}>PERIOD</th>
//                                     <th style={{ color: '#1e293b' }}>STATUS</th>
//                                     <th style={{ color: '#1e293b' }}>ACTION</th>
//                                 </tr>
//                             </thead>
//                             <tbody>
//                                 {reports.length > 0 ? reports.map((report) => (
//                                     <tr key={report.id} className="history-row">
//                                         <td style={{ fontWeight: '700' }}>{report.empid}</td>
//                                         {/* Updated to match PascalCase from tblemployees table */}
//                                         <td>{report.FirstName} {report.LastName}</td>
//                                         <td>{report.fromdate} <span style={{color: '#3b82f6'}}>→</span> {report.todate}</td>
//                                         <td>
//                                             {viewMode === 'history' ? (
//                                                 <span className={`status-pill ${String(report.medical_doc_status) === '1' ? 'approved' : 'rejected'}`}>
//                                                     {String(report.medical_doc_status) === '1' ? 'VERIFIED' : 'REJECTED'}
//                                                 </span>
//                                             ) : (
//                                                 <span className="status-pill pending">WAITING</span>
//                                             )}
//                                         </td>
//                                         <td>
//                                             <button className="btn-action approve" onClick={() => handleViewDocument(report.medical_doc, report.id)}>
//                                                 OPEN_FILE
//                                             </button>
//                                         </td>
//                                     </tr>
//                                 )) : (
//                                     <tr>
//                                         <td colSpan="5" style={{ textAlign: 'center', padding: '50px', color: '#94a3b8' }}>
//                                             No medical reports found for the {managerDept || 'selected'} department.
//                                         </td>
//                                     </tr>
//                                 )}
//                             </tbody>
//                         </table>
//                     )}
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default ManagerMedicalReports;












// import React, { useState, useEffect } from 'react';
// import '../styles/Attendance.css';

// const ManagerMedicalReports = () => {
//     const [reports, setReports] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const [viewMode, setViewMode] = useState('pending');
//     const [selectedPhoto, setSelectedPhoto] = useState(null);
//     const [selectedLeaveId, setSelectedLeaveId] = useState(null);
//     // Get the data and parse it safely
//     const storedUser = localStorage.getItem('userData');
//     const userData = storedUser ? JSON.parse(storedUser) : null;

//     // Use optional chaining and trim() to handle hidden spaces
//     const managerDept = userData && userData.HOD ? userData.HOD.trim() : '';

//     const fetchReports = async () => {
//         if (!managerDept) {
//             console.error("Manager HOD is missing");
//             setLoading(false);
//             return;
//         }

//         setLoading(true);
//         try {
//             // DYNAMIC: This sends whatever is in the HOD column to PHP
//             const url = `/gt-api/get_manager_medical_reports.php?mode=${viewMode}&dept=${encodeURIComponent(managerDept)}`;

//             const response = await fetch(url);
//             const data = await response.json();

//             if (data.success) {
//                 setReports(data.reports);
//             } else {
//                 setReports([]);
//             }
//         } catch (error) {
//             console.error("Fetch Error:", error);
//             setReports([]);
//         } finally {
//             setLoading(false);
//         }
//     };

//     const handleViewDocument = (fileName, leaveId) => {
//         const fileUrl = `/gt-api/uploads/medical_docs/${fileName}`;
//         setSelectedLeaveId(leaveId);
//         setSelectedPhoto(fileUrl);
//     };

//     const handleVerifyAction = async (actionType) => {
//         if (!selectedLeaveId) return;

//         const formData = new URLSearchParams();
//         formData.append('leave_id', selectedLeaveId);
//         formData.append('action', actionType);

//         try {
//             const response = await fetch("/gt-api/update_medical_status.php", {
//                 method: "POST",
//                 headers: { "Content-Type": "application/x-www-form-urlencoded" },
//                 body: formData.toString()
//             });
//             const result = await response.json();
//             if (result.success) {
//                 setSelectedPhoto(null);
//                 fetchReports();
//                 alert(`Document ${actionType === 'verify' ? 'Approved' : 'Rejected'} Successfully`);
//             }
//         } catch (error) {
//             console.error("Update Error:", error);
//         }
//     };

//     // ADD THIS BLOCK
//     useEffect(() => {
//         fetchReports();
//     }, [viewMode, managerDept]); // This runs every time the tab or department changes

//     return (
//         <div className="attendance-module animate-fade">

//             {/* DOCUMENT OVERLAY */}
//             {/* {selectedPhoto && (
//                 <div className="cyber-full-overlay"
//                     onClick={() => setSelectedPhoto(null)}
//                     style={{
//                         position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh',
//                         background: 'rgba(255, 255, 255, 0.95)', zIndex: 9999,
//                         display: 'flex', flexDirection: 'column', alignItems: 'center',
//                         justifyContent: 'center', backdropFilter: 'blur(10px)'
//                     }}>

//                     <div style={{ background: '#fff', padding: '20px', borderRadius: '15px', boxShadow: '0 20px 50px rgba(0,0,0,0.1)', textAlign: 'center' }}>
//                         <h4 style={{ color: '#1e293b', marginBottom: '15px' }}>MEDICAL DOCUMENT VERIFICATION</h4>

//                         {viewMode === 'pending' && (
//                             <div style={{ display: 'flex', gap: '15px', marginBottom: '20px', justifyContent: 'center' }}>
//                                 <button className="btn-submit-cyber" onClick={(e) => { e.stopPropagation(); handleVerifyAction('verify'); }}>✓ APPROVE</button>
//                                 <button className="btn-no" style={{ background: '#ef4444', color: '#fff', border: 'none', padding: '10px 20px', borderRadius: '5px', fontWeight: 'bold' }} onClick={(e) => { e.stopPropagation(); handleVerifyAction('reject'); }}>✕ REJECT</button>
//                             </div>
//                         )}

//                         <img src={selectedPhoto} alt="Medical Report" style={{ maxWidth: '70vw', maxHeight: '60vh', borderRadius: '8px', border: '1px solid #e2e8f0' }} onClick={(e) => e.stopPropagation()} />
//                         <p style={{ color: '#64748b', marginTop: '15px', fontSize: '0.8rem' }}>Click anywhere outside to close</p>
//                     </div>
//                 </div>
//             )} */}

//             {selectedPhoto && (
//                 <div className="cyber-full-overlay" onClick={() => setSelectedPhoto(null)} style={{ position: 'fixed', top: 0, left: 0, width: '80vw', height: '90vh', background: 'rgba(0,0,0,0.95)', zIndex: 9999, display: 'flex', flexDirection: 'column', alignItems: 'center', paddingTop: '20px', overflowY: 'auto' }}>

//                     {/* Only show buttons if we are in Pending mode */}
//                     {viewMode === 'pending' && (
//                         <div style={{ display: 'flex', gap: '20px', marginBottom: '20px', position: 'sticky', top: 0 }}>
//                             <button className="btn-yes" onClick={() => handleVerifyAction('verify')}>✓ APPROVE</button>
//                             <button className="btn-no" onClick={() => handleVerifyAction('reject')}>✕ REJECT</button>
//                         </div>
//                     )}

//                     <img src={selectedPhoto} alt="Log" style={{ maxWidth: '50%', height: '450px', border: '2px solid #00f2ff', borderRadius: '8px' }} onClick={(e) => e.stopPropagation()} />
//                     <p style={{ color: '#fff', margin: '20px 0' }}>Click outside to close</p>
//                 </div>
//             )}

//             <div className="panel glass">
//                 <div className="panel-header">
//                     <div style={{ display: 'flex', gap: '20px' }}>
//                         <h3
//                             className={`panel-title ${viewMode === 'pending' ? 'active-tab' : 'inactive-tab'}`}
//                             onClick={() => setViewMode('pending')}
//                             style={{ cursor: 'pointer', borderBottom: viewMode === 'pending' ? '2px solid #00f2ff' : 'none' }}
//                         >
//                             PENDING_DOCS
//                         </h3>
//                         <h3
//                             className={`panel-title ${viewMode === 'history' ? 'active-tab' : 'inactive-tab'}`}
//                             onClick={() => setViewMode('history')}
//                             style={{ cursor: 'pointer', borderBottom: viewMode === 'history' ? '2px solid #00f2ff' : 'none' }}
//                         >
//                             APPLICATION_LOG (HISTORY)
//                         </h3>
//                     </div>
//                     <span className="deduction-badge">{reports.length} FILES</span>
//                 </div>

//                 <div className="table-scroll">
//                     {loading ? (
//                         <div style={{ padding: '40px', textAlign: 'center', color: '#64748b' }}>Loading Department Data...</div>
//                     ) : (
//                         <table className="history-table">
//                             <thead>
//                                 <tr >
//                                     <th >EMP_ID</th>
//                                     <th >EMPLOYEE_NAME</th>
//                                     <th >PERIOD</th>
//                                     <th >STATUS</th>
//                                     <th >ACTION</th>
//                                 </tr>
//                             </thead>
//                             <tbody>
//                                 {reports.length > 0 ? reports.map((report) => (
//                                     <tr key={report.id} className="history-row">
//                                         <td style={{ fontWeight: '700' }}>{report.empid}</td>

//                                         <td>{report.FirstName} {report.LastName}</td>
//                                         <td>{report.fromdate} <span style={{ color: '#3b82f6' }}>→</span> {report.todate}</td>
//                                         {/* <td>
//                                             {viewMode === 'history' ? (
//                                                 <span className={`status-pill ${report.medical_doc_status === '1' ? 'approved' : 'rejected'}`}>
//                                                     {report.medical_doc_status === '1' ? 'VERIFIED' : 'REJECTED'}
//                                                 </span>
//                                             ) : (
//                                                 <span className="status-pill pending">WAITING</span>
//                                             )}
//                                         </td> */}

                                      
//                                         <td>
//                                             {viewMode === 'history' ? (
//                                                 <span className={`status-pill ${Number(report.medical_doc_status) === 1 ? 'approved' : 'rejected'}`}>
//                                                     {Number(report.medical_doc_status) === 1 ? 'VERIFIED' : 'REJECTED'}
//                                                 </span>
//                                             ) : (
//                                                 <span className="status-pill pending">WAITING</span>
//                                             )}
//                                         </td>
//                                         <td>
//                                             <button className="action-upload" onClick={() => handleViewDocument(report.medical_doc, report.id)}>
//                                                 VIEW_LOG
//                                             </button>
//                                         </td>
//                                     </tr>
//                                 )) : (
//                                     <tr>
//                                         <td colSpan="5" style={{ textAlign: 'center', padding: '50px', color: '#94a3b8' }}>
//                                             No medical reports found for the {managerDept} department.
//                                         </td>
//                                     </tr>
//                                 )}
//                             </tbody>
//                         </table>
//                     )}
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default ManagerMedicalReports;







// working but not fetching medical reports 

// import React, { useState, useEffect } from 'react';
// import '../styles/Attendance.css';

// const ManagerMedicalReports = () => {
//     const [reports, setReports] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const [viewMode, setViewMode] = useState('pending');
//     const [selectedPhoto, setSelectedPhoto] = useState(null);
//     const [selectedLeaveId, setSelectedLeaveId] = useState(null);
    
//     const storedUser = localStorage.getItem('userData');
//     const userData = storedUser ? JSON.parse(storedUser) : null;
//     const managerDept = userData && userData.HOD ? userData.HOD.trim() : '';
//     

//     const fetchReports = async () => {
//         if (!managerDept) {
//             console.error("Manager HOD is missing");
//             setLoading(false);
//             return;
//         }

//         setLoading(true);
//         try {
//             const url = `/gt-api/get_manager_medical_reports.php?mode=${viewMode}&dept=${encodeURIComponent(managerDept)}`;
//             const response = await fetch(url);
//             const data = await response.json();

//             if (data.success) {
//                 setReports(data.reports);
//             } else {
//                 setReports([]);
//             }
//         } catch (error) {
//             console.error("Fetch Error:", error);
//             setReports([]);
//         } finally {
//             setLoading(false);
//         }
//     };

//     const handleViewDocument = (fileName, leaveId) => {
//         const fileUrl = `/gt-api/uploads/medical_docs/${fileName}`;
//         setSelectedLeaveId(leaveId);
//         setSelectedPhoto(fileUrl);
//     };

//     const handleVerifyAction = async (actionType) => {
//         if (!selectedLeaveId) return;

//         const formData = new URLSearchParams();
//         formData.append('leave_id', selectedLeaveId);
//         formData.append('action', actionType);

//         try {
//             const response = await fetch("/gt-api/update_medical_status.php", {
//                 method: "POST",
//                 headers: { "Content-Type": "application/x-www-form-urlencoded" },
//                 body: formData.toString()
//             });
//             const result = await response.json();
//             if (result.success) {
//                 setSelectedPhoto(null);
//                 fetchReports();
//                 alert(`Document ${actionType === 'verify' ? 'Approved' : 'Rejected'} Successfully`);
//             }
//         } catch (error) {
//             console.error("Update Error:", error);
//         }
//     };

//     useEffect(() => {
//         fetchReports();
//     }, [viewMode, managerDept]);

//     return (
//         <div className="attendance-module animate-fade">

//             {/* DOCUMENT OVERLAY */}
//             {selectedPhoto && (
//                 <div className="cyber-full-overlay" onClick={() => setSelectedPhoto(null)} style={{ position: 'fixed', top: 0, left: 0, width: '80vw', height: '90vh', background: 'rgba(0,0,0,0.95)', zIndex: 9999, display: 'flex', flexDirection: 'column', alignItems: 'center', paddingTop: '20px', overflowY: 'auto' }}>
//                     {viewMode === 'pending' && (
//                         <div style={{ display: 'flex', gap: '20px', marginBottom: '20px', position: 'sticky', top: 0 }}>
//                             <button className="btn-yes" onClick={() => handleVerifyAction('verify')}>✓ APPROVE</button>
//                             <button className="btn-no" onClick={() => handleVerifyAction('reject')}>✕ REJECT</button>
//                         </div>
//                     )}
//                     <img src={selectedPhoto} alt="Log" style={{ maxWidth: '50%', height: '450px', border: '2px solid #00f2ff', borderRadius: '8px' }} onClick={(e) => e.stopPropagation()} />
//                     <p style={{ color: '#fff', margin: '20px 0' }}>Click outside to close</p>
//                 </div>
//             )}

//             <div className="panel glass">
//                 <div className="panel-header">
//                     <div style={{ display: 'flex', gap: '20px' }}>
//                         <h3
//                             className={`panel-title ${viewMode === 'pending' ? 'active-tab' : 'inactive-tab'}`}
//                             onClick={() => setViewMode('pending')}
//                             style={{ cursor: 'pointer', borderBottom: viewMode === 'pending' ? '2px solid #00f2ff' : 'none' }}
//                         >
//                             PENDING_DOCS
//                         </h3>
//                         <h3
//                             className={`panel-title ${viewMode === 'history' ? 'active-tab' : 'inactive-tab'}`}
//                             onClick={() => setViewMode('history')}
//                             style={{ cursor: 'pointer', borderBottom: viewMode === 'history' ? '2px solid #00f2ff' : 'none' }}
//                         >
//                             APPLICATION_LOG (HISTORY)
//                         </h3>
//                     </div>
//                     <span className="deduction-badge">{reports.length} FILES</span>
//                 </div>

//                 <div className="table-scroll">
//                     {loading ? (
//                         <div style={{ padding: '40px', textAlign: 'center', color: '#64748b' }}>Loading Department Data...</div>
//                     ) : (
//                         <table className="history-table">
//                             <thead>
//                                 <tr>
//                                     <th>EMP_ID</th>
//                                     <th>EMPLOYEE_NAME</th>
//                                     <th>PERIOD</th>
//                                     <th>STATUS</th>
//                                     <th>ACTION</th>
//                                 </tr>
//                             </thead>
//                             <tbody>
//                                 {reports.length > 0 ? reports.map((report) => (
//                                     <tr key={report.id} className="history-row">
//                                         {/* CHANGED: Displaying report.EmpId instead of report.empid */}
//                                         <td style={{ fontWeight: '700' }}>{report.EmpId}</td>

//                                         <td>{report.FirstName} {report.LastName}</td>
//                                         <td>{report.fromdate} <span style={{ color: '#3b82f6' }}>→</span> {report.todate}</td>
//                                         <td>
//                                             {viewMode === 'history' ? (
//                                                 <span className={`status-pill ${Number(report.medical_doc_status) === 1 ? 'approved' : 'rejected'}`}>
//                                                     {Number(report.medical_doc_status) === 1 ? 'VERIFIED' : 'REJECTED'}
//                                                 </span>
//                                             ) : (
//                                                 <span className="status-pill pending">WAITING</span>
//                                             )}
//                                         </td>
//                                         <td>
//                                             <button className="action-upload" onClick={() => handleViewDocument(report.medical_doc, report.id)}>
//                                                 VIEW_LOG
//                                             </button>
//                                         </td>
//                                     </tr>
//                                 )) : (
//                                     <tr>
//                                         <td colSpan="5" style={{ textAlign: 'center', padding: '50px', color: '#94a3b8' }}>
//                                             No medical reports found for the {managerDept} department.
//                                         </td>
//                                     </tr>
//                                 )}
//                             </tbody>
//                         </table>
//                     )}
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default ManagerMedicalReports;















import React, { useState, useEffect } from 'react';
import '../styles/Attendance.css';

const ManagerMedicalReports = () => {
    const [reports, setReports] = useState([]);
    const [loading, setLoading] = useState(true);
    const [viewMode, setViewMode] = useState('pending');
    const [selectedPhoto, setSelectedPhoto] = useState(null);
    const [selectedLeaveId, setSelectedLeaveId] = useState(null);
    
    const storedUser = localStorage.getItem('userData');
    const userData = storedUser ? JSON.parse(storedUser) : null;
    const managerDept = userData && userData.HOD ? userData.HOD.trim() : '';
    // const managerDept = userData && userData.Department ? userData.Department.trim() : '';
    const managerId = userData ? userData.id : null;

    const fetchReports = async () => {
        if (!managerDept) {
            console.error("Manager HOD is missing");
            setLoading(false);
            return;
        }

        setLoading(true);
        try {
            const url = `/gt-api/get_manager_medical_reports.php?mode=${viewMode}&dept=${encodeURIComponent(managerDept)}`;
            const response = await fetch(url);
            const data = await response.json();

            if (data.success) {
                setReports(data.reports);
            } else {
                setReports([]);
            }
        } catch (error) {
            console.error("Fetch Error:", error);
            setReports([]);
        } finally {
            setLoading(false);
        }
    };

    const handleViewDocument = (fileName, leaveId) => {
        const fileUrl = `/gt-api/uploads/medical_docs/${fileName}`;
        setSelectedLeaveId(leaveId);
        setSelectedPhoto(fileUrl);
    };

    const handleVerifyAction = async (actionType) => {
        if (!selectedLeaveId) return;

        const formData = new URLSearchParams();
        formData.append('leave_id', selectedLeaveId);
        formData.append('action', actionType);

        try {
            const response = await fetch("/gt-api/update_medical_status.php", {
                method: "POST",
                headers: { "Content-Type": "application/x-www-form-urlencoded" },
                body: formData.toString()
            });
            const result = await response.json();
            if (result.success) {
                setSelectedPhoto(null);
                fetchReports();
                alert(`Document ${actionType === 'verify' ? 'Approved' : 'Rejected'} Successfully`);
            }
        } catch (error) {
            console.error("Update Error:", error);
        }
    };

    useEffect(() => {
    fetchReports();
    // Use managerDept as the dependency
}, [viewMode, managerDept]);

    return (
        <div className="attendance-module animate-fade">

            {/* DOCUMENT OVERLAY */}
            {selectedPhoto && (
                <div className="cyber-full-overlay" onClick={() => setSelectedPhoto(null)} style={{ position: 'fixed', top: 0, left: 0, width: '80vw', height: '90vh', background: 'rgba(0,0,0,0.95)', zIndex: 9999, display: 'flex', flexDirection: 'column', alignItems: 'center', paddingTop: '20px', overflowY: 'auto' }}>
                    {viewMode === 'pending' && (
                        <div style={{ display: 'flex', gap: '20px', marginBottom: '20px', position: 'sticky', top: 0 }}>
                            <button className="btn-yes" onClick={() => handleVerifyAction('verify')}>✓ APPROVE</button>
                            <button className="btn-no" onClick={() => handleVerifyAction('reject')}>✕ REJECT</button>
                        </div>
                    )}
                    <img src={selectedPhoto} alt="Log" style={{ maxWidth: '50%', height: '450px', border: '2px solid #00f2ff', borderRadius: '8px' }} onClick={(e) => e.stopPropagation()} />
                    <p style={{ color: '#fff', margin: '20px 0' }}>Click outside to close</p>
                </div>
            )}

            <div className="panel glass">
                <div className="panel-header">
                    <div style={{ display: 'flex', gap: '20px' }}>
                        <h3
                            className={`panel-title ${viewMode === 'pending' ? 'active-tab' : 'inactive-tab'}`}
                            onClick={() => setViewMode('pending')}
                            style={{ cursor: 'pointer', borderBottom: viewMode === 'pending' ? '2px solid #00f2ff' : 'none' }}
                        >
                            PENDING_DOCS
                        </h3>
                        <h3
                            className={`panel-title ${viewMode === 'history' ? 'active-tab' : 'inactive-tab'}`}
                            onClick={() => setViewMode('history')}
                            style={{ cursor: 'pointer', borderBottom: viewMode === 'history' ? '2px solid #00f2ff' : 'none' }}
                        >
                            APPLICATION_LOG (HISTORY)
                        </h3>
                    </div>
                    <span className="deduction-badge">{reports.length} FILES</span>
                </div>

                <div className="table-scroll">
                    {loading ? (
                        <div style={{ padding: '40px', textAlign: 'center', color: '#64748b' }}>Loading Department Data...</div>
                    ) : (
                        <table className="history-table">
                            <thead>
                                <tr>
                                    <th>EMP_ID</th>
                                    <th>EMPLOYEE_NAME</th>
                                    <th>PERIOD</th>
                                    <th>STATUS</th>
                                    <th>ACTION</th>
                                </tr>
                            </thead>
                            <tbody>
                                {reports.length > 0 ? reports.map((report) => (
                                    <tr key={report.id} className="history-row">
                                        {/* CHANGED: Displaying report.EmpId instead of report.empid */}
                                        <td style={{ fontWeight: '700' }}>{report.EmpId}</td>

                                        <td>{report.FirstName} {report.LastName}</td>
                                        <td>{report.fromdate} <span style={{ color: '#3b82f6' }}>→</span> {report.todate}</td>
                                        <td>
                                            {viewMode === 'history' ? (
                                                <span className={`status-pill ${Number(report.medical_doc_status) === 1 ? 'approved' : 'rejected'}`}>
                                                    {Number(report.medical_doc_status) === 1 ? 'VERIFIED' : 'REJECTED'}
                                                </span>
                                            ) : (
                                                <span className="status-pill pending">WAITING</span>
                                            )}
                                        </td>
                                        <td>
                                            <button className="action-upload" onClick={() => handleViewDocument(report.medical_doc, report.id)}>
                                                VIEW_LOG
                                            </button>
                                        </td>
                                    </tr>
                                )) : (
                                    <tr>
                                        <td colSpan="5" style={{ textAlign: 'center', padding: '50px', color: '#94a3b8' }}>
                                            No medical reports found for the {managerDept} department.
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ManagerMedicalReports;